import React, { useState, useEffect } from 'react';
import './InterviewSchedule.css';

const ProfileDetails = ({ applicant }) => {

    const formatDateAPI = (date) => {
        return new Date(date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          }).replace(',', '');
    }

    return (
        <div className="profile-content">
            <div className="personal-info-section">
                <h3>Personal Info</h3>
                <div className="info-grid">
                <div className="info-item">
                    <span className="info-label">Full Name</span>
                    <span className="info-value">{applicant.user_names}</span>
                </div>
                <div className="info-item">
                    <span className="info-label">Gender</span>
                    <span className="info-value">{applicant.gender || 'M'}</span>
                </div>
                <div className="info-item">
                    <span className="info-label">Date of Birth</span>
                    <span className="info-value">
                    {formatDateAPI(applicant.dob)}
                    </span>
                </div>
                <div className="info-item">
                    <span className="info-label">Language</span>
                    {applicant.languages.map(language => (
                        <span className="info-value">{language.name}</span>
                    ))}
                </div>
                <div className="info-item">
                    <span className="info-label">Address</span>
                    
                    {applicant.addresses.map(address => (
                    <span className="info-value">
                        {address.street_address}<br />
                        {address.city}
                    </span>
                    ))}
                </div>
                </div>
            </div>

            <div className="professional-info-section">
                <h3>Professional Info</h3>
                <div className="about-section">
                <h4>About Me</h4>
                <p className="about-text">{applicant.bio}</p>
                </div>
                
                <div className="professional-grid">
                {/* <div className="professional-item">
                    <span className="professional-label">Current Job</span>
                    <span className="professional-value">{applicant.professionalInfo.currentJob || ""}</span>
                </div> */}
                {/* <div className="professional-item">
                    <span className="professional-label">Experience in Years</span>
                    <span className="professional-value">{applicant.work_experience[0].experienceYears}</span>
                </div> */}
                {/* <div className="professional-item">
                    <span className="professional-label">Highest Qualification Held</span>
                    <span className="professional-value">{applicant.education[0].degree}</span>
                </div> */}
                <div className="professional-item">
                    <span className="professional-label">Skill set</span>
                    <div className="skills-container">
                    {applicant.skills.map((skill, index) => (
                        <span key={index} className="skill-tag">{skill.name}</span>
                    ))}
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
};
export default ProfileDetails;